<template>
  <!-- Main content -->
  <section class="content">
    <div class="warning-block">
      <span class="text-red">＊</span>
      月報表模組已搬至「
      <a @click="goto" class="cursor-pointer">報表中心 > 報表下載區 > 定期報表</a>
      」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。
    </div>
    <!--<system-chart v-if="roleType === 99"></system-chart>-->
    <!--<brand-chart v-if="roleType === 30"></brand-chart>-->
    <chart-share v-if="roleType === 99 || roleType === 30"></chart-share>
  </section>
  <!-- /.content -->
</template>

<script>
import systemChart from './Temp/SystemChart.vue'
import brandChart from './Temp/BrandChart.vue'
import chartShare from './Temp/ChartShare.vue'

import { mapGetters } from 'vuex'
import { setSharedToken } from '../../../assets/js/shared-token.js'

export default {
  components: {
    'system-chart': systemChart,
    'brand-chart': brandChart,
    'chart-share': chartShare
  },
  data () {
    return {
      roleType: 99
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
  },
  methods: {
    goto () {
      setSharedToken(window.localStorage.getItem(this.$config.token))
      window.location.href = `${this.$config.bdms}report-center/downloads?mainTab=1&subTab=1`
    }
  }

}
</script>
<style lang="sass" scope>
@media screen and (max-width: 767px)
  .box-title
    text-align: center
    width: 100%
</style>



// WEBPACK FOOTER //
// ChartDash.vue?5a68ab31